
<div class="create-season-back-dialog-container">
    <div class="create-season-back-dialog-header-container">
        <div>  <p class="create-season-back-dialog-header-text create-season-back-section-headers">BACK</p></div>
        <div><p class="create-season-back-dialog-sub-heading">All changes will be lost, are you sure?</p></div>
    </div>

    <div class="create-season-back-btn-dialog-container">

        <button class="cancel-create-season-back-dialog-btn" mat-flat-button type="button" (click)="cancel()">
            <div class="cancel-create-season-back-btn-content">
                <span><p class="cancel-create-season-back-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="create-season-back-btn mdc-button mdc-button--outlined"  type="button" (click)="back()">
            <div class="create-season-back-btn-content">
                <img src="../../../assets/icons/arrow-back.svg" alt="Back Icon" class="create-season-back-btn-icon">
                <span><p class="create-season-back-btn-text">BACK</p></span>
            </div>
        </button>
    </div>

</div>



